import { ReceptionInfo } from "../../reception/reception-info";
import { Reference } from "../../reference/reference";

export enum PriceChangeStatus {
  TO_PROCESS = "TO_PROCESS",
  APPLIED = "APPLIED",
  IGNORED = "IGNORED"
}

export class PriceChange {
  creationTimestamp!: Date;
  id!: string;
  oldPrice!: number;
  newPrice!: number;
  reference!: Reference;
  reception!: ReceptionInfo;
  status!: PriceChangeStatus;
  updateTimestamp!: Date;
}